/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CancelPaymentAuthorizationResponse
 */
export interface CancelPaymentAuthorizationResponse {
    /**
     * Stripe PaymentIntent id (`pi_xxx`).
     * @type {string}
     * @memberof CancelPaymentAuthorizationResponse
     */
    paymentIntentId: string;
    /**
     * Stripe PaymentIntent.status after cancel.
     * @type {string}
     * @memberof CancelPaymentAuthorizationResponse
     */
    status?: string | null;
    /**
     * True iff `status == "canceled"`.
     * @type {boolean}
     * @memberof CancelPaymentAuthorizationResponse
     */
    succeeded: boolean;
}

/**
 * Check if a given object implements the CancelPaymentAuthorizationResponse interface.
 */
export function instanceOfCancelPaymentAuthorizationResponse(value: object): value is CancelPaymentAuthorizationResponse {
    if (!('paymentIntentId' in value) || value['paymentIntentId'] === undefined) return false;
    if (!('succeeded' in value) || value['succeeded'] === undefined) return false;
    return true;
}

export function CancelPaymentAuthorizationResponseFromJSON(json: any): CancelPaymentAuthorizationResponse {
    return CancelPaymentAuthorizationResponseFromJSONTyped(json, false);
}

export function CancelPaymentAuthorizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelPaymentAuthorizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentIntentId': json['payment_intent_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'succeeded': json['succeeded'],
    };
}

export function CancelPaymentAuthorizationResponseToJSON(json: any): CancelPaymentAuthorizationResponse {
    return CancelPaymentAuthorizationResponseToJSONTyped(json, false);
}

export function CancelPaymentAuthorizationResponseToJSONTyped(value?: CancelPaymentAuthorizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_intent_id': value['paymentIntentId'],
        'status': value['status'],
        'succeeded': value['succeeded'],
    };
}

